module.exports = __webpack_public_path__ + "img/Station Planning_01.a35b0931.jpg";